export enum GraphQLEvent {
    ERROR = 'ERROR',
    REDIRECT = 'REDIRECT',
}
